import { useState, useEffect } from 'react';
import {
	Form,
	FormControl,
	Button,
	Card,
	InputGroup,
	Alert,
} from 'react-bootstrap';
import { PHP } from '../utils/axiosConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';

function ChangePassword({ goHome = null }) {
	const php = PHP();
	const [passwords, setPasswords] = useState({
		new: '',
		confirm: '',
	});
	const [warning, setWarning] = useState('');
	const [matchingPasswords, setMatchingPasswords] = useState(null);
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [updateSuccess, setUpdateSuccess] = useState(false);

	const handleChangePassword = (e) => {
		setPasswords({ ...passwords, [e.target.name]: e.target.value });
		if (e.target.name === 'new') {
			//Uppercase letter
			const lowerRegex = new RegExp(/(?=.*[a-z])/);
			const upperRegex = new RegExp(/(?=.*[A-Z])/);
			const numberRegex = new RegExp(/(?=.*\d)/);
			const specialRegex = new RegExp(/(?=.*[@$!%*?&])/);
			const eightCharRegex = new RegExp(/[A-Za-z\d@$!%*?&]{8,}/);
			let warning = 'Must include ';
			let violations = [];
			if (!upperRegex.test(e.target.value)) {
				violations.push('one uppercase letter');
			}
			if (!lowerRegex.test(e.target.value)) {
				violations.push('one lowercase letter');
			}
			if (!numberRegex.test(e.target.value)) {
				violations.push('one number');
			}
			if (!specialRegex.test(e.target.value)) {
				violations.push('one special character (@$!%*?&)');
			}
			if (!eightCharRegex.test(e.target.value)) {
				violations.push('must be at least 8 characters in length');
			}
			violations.forEach((v, i) => {
				if (i === 0) {
					warning += ', ' + v;
				} else if (i === violations.length - 1) {
					warning += ', ' + v + '.';
				} else {
					warning += ', ' + v;
				}
			});
			if (violations.length === 0) {
				setWarning('');
			} else {
				setWarning(warning);
			}
		}
	};
	useEffect(() => {
		if (passwords.confirm && passwords.new !== passwords.confirm) {
			setMatchingPasswords(false);
		}
		if (passwords.confirm && passwords.new === passwords.confirm) {
			setMatchingPasswords(true);
		}
	}, [passwords]);

	const savePassword = (e) => {
		e.preventDefault();
		//TODO: send request to save the password
		const formData = new FormData();
		formData.append('route', 'change_password');
		formData.append('password', passwords.new);
		php
			.post('user.php', formData)
			.then((res) => {
				if (res.status == 200) {
					console.log(res);
					setUpdateSuccess(true);
				}
			})
			.catch((err) => console.log(err));
	};

	useEffect(() => {
		let timer;
		if (updateSuccess) {
			timer = setTimeout(() => {
				setPasswords({ new: '', confirm: '' });
				setUpdateSuccess(false);
				if (goHome) {
					goHome();
				}
			}, 3000);
		}
		return () => clearTimeout(timer);
	}, [updateSuccess]);

	return (
		<Card>
			<Card.Body>
				<Form onSubmit={savePassword}>
					<Form.Group>
						<Form.Label>New Password</Form.Label>
						<InputGroup>
							<FormControl
								type={showNewPassword ? 'text' : 'password'}
								name="new"
								value={passwords.new}
								onChange={handleChangePassword}
								isInvalid={warning}
								isValid={!warning && passwords.new.length >= 8}
								disabled={updateSuccess}
							/>
							<FontAwesomeIcon
								icon={faEye}
								style={{
									position: 'absolute',
									right: '2rem',
									top: '50%',
									transform: 'translateY(-50%)',
									cursor: 'pointer',
									color: showNewPassword ? '#000' : '#ccc',
									zIndex: '100',
								}}
								onClick={() => setShowNewPassword(!showNewPassword)}
							/>
						</InputGroup>
						{warning && <Form.Text>{warning}</Form.Text>}
					</Form.Group>
					<Form.Group>
						<Form.Label>Confirm Password</Form.Label>
						<InputGroup>
							<FormControl
								type={showConfirmPassword ? 'text' : 'password'}
								name="confirm"
								value={passwords.confirm}
								onChange={handleChangePassword}
								isInvalid={
									!matchingPasswords &&
									passwords.new.length >= 8 &&
									passwords.confirm.length > 0
								}
								isValid={matchingPasswords && passwords.new.length >= 8}
								disabled={updateSuccess}
							/>
							<FontAwesomeIcon
								icon={faEye}
								style={{
									position: 'absolute',
									right: '2rem',
									top: '50%',
									transform: 'translateY(-50%)',
									cursor: 'pointer',
									color: showConfirmPassword ? '#000' : '#ccc',
									zIndex: '100',
								}}
								onClick={() => setShowConfirmPassword(!showConfirmPassword)}
							/>
						</InputGroup>
						{!matchingPasswords &&
							passwords.new.length >= 8 &&
							passwords.confirm.length > 0 && (
								<Form.Text>Passwords must match.</Form.Text>
							)}
					</Form.Group>
					{!updateSuccess ? (
						<div className="d-flex justify-content-end mt-4">
							<Button
								type="submit"
								variant="primary"
								onClick={savePassword}
								disabled={!matchingPasswords || warning}
							>
								Save Password
							</Button>
						</div>
					) : (
						<Alert variant="success" className="text-center">
							Password updated.
						</Alert>
					)}
				</Form>
			</Card.Body>
		</Card>
	);
}

export default ChangePassword;
